import React from 'react';
import { useAppSelector } from '../../../../store/hooks';
import { orderDetailsHeadSelector } from '../../../../store/selectors/ordersSelector';
import { TruncateTooltip } from '../../../../common/components/truncate-tooltip/TruncateTooltip';
import Tag from '../../../../core/components/tag/Tag';

const OrderHead:React.FC = () => {
  const entities = useAppSelector(orderDetailsHeadSelector);

  return (
    <>
      {entities.map((ent, i) => <div key={i} className="head__inner-info-item">
        <TruncateTooltip value={ent.label} className="head__inner-info-item__label" />
        {ent.label === 'Customer type'
          ? <Tag label={ent.value?.toString() || '-'} />
          : <TruncateTooltip className="head__inner-info-item__value" value={ent.value ? ent.value.toString() : '-'} />}
      </div>)}
    </>
  );
};

export default OrderHead;
